import React from "react";
import { AnnualWheelMonthEnum } from "./AnnualWheel.types.ts";
import { useUserContext } from "../auth/userContextProvider/UserContextProvider.tsx";
import { useTranslation } from "../localization/useTranslation.ts";
import { useUrlProvider } from "../useUrlProvider.ts";
import { DotLegalOverflowMenu } from "@dotlegal/dotlegal-ui-components";

export interface IAnnualWheelOverflowMenuProps {
    id: string;
    month?: AnnualWheelMonthEnum;
    deleted: boolean;
    partOfCurrentPlan: boolean;
    onEditClick: () => void;
    onDeleteClick: () => void;
    isObligation?: boolean;
}

function AnnualWheelOverflowMenu(props: IAnnualWheelOverflowMenuProps) {
    const { translateString } = useTranslation();
    const { getTaskManagementUrlForTask } = useUrlProvider();
    const { permissions } = useUserContext();
    const contractPermissions = permissions.contractManagementPermissions.permissions;
    const activityPermissions = props.isObligation ? { ...contractPermissions, delete: contractPermissions.edit } : permissions.annualWheelPermission;
    const showOverFlowMenu = () => {
        if (props.deleted) {
            return activityPermissions.delete;
        }

        return activityPermissions.edit || activityPermissions.delete || permissions.taskPermissions.read;
    };

    const getMenuItems = () => {
        if (props.deleted && activityPermissions.delete) {
            return [
                {
                    menuItem: translateString("delete"),
                    onClick: () => {
                        props.onDeleteClick();
                    },
                },
            ];
        }

        let menuItems = [];

        if (permissions.taskPermissions.read) {
            menuItems.push({
                menuItem: translateString("viewActivityTasksInTaskManagement"),
                href: getTaskManagementUrlForTask(props.month, props.id),
            });
        }

        if (activityPermissions.edit && props.partOfCurrentPlan) {
            menuItems.push({
                menuItem: translateString("edit"),
                onClick: () => {
                    props.onEditClick();
                },
            });
        }

        if (activityPermissions.delete) {
            menuItems.push({
                menuItem: translateString("delete"),
                onClick: () => {
                    props.onDeleteClick();
                },
            });
        }

        return menuItems;
    };

    return <>{showOverFlowMenu() && <DotLegalOverflowMenu items={getMenuItems()} />}</>;
}

export default AnnualWheelOverflowMenu;
